import type { FetchPolicy } from 'apollo-client';
import { compose, setDisplayName, withProps } from 'recompose';

import withPremiumProductCollections from 'bundles/browse-common/legacy/components/hoc/withPremiumProductCollections';
import type { DegreeCardDegreeProps, DegreeProductMember } from 'bundles/browse-common/legacy/types/degree';

type PremiumProductProps = DegreeProductMember & DegreeCardDegreeProps;

export type ApiInputProps = {
  domains: string[] | null;
  productVariants?: string[] | null;
  ssr?: boolean;
  fetchPolicy?: FetchPolicy;
};

export type PremiumProductCollectionOutputProps = {
  degreeListFromPremiumProductsCollection?: PremiumProductProps[];
  mastertrackListFromPremiumProductsCollection?: PremiumProductProps[];
  universityCertificateListFromPremiumProductsCollection?: PremiumProductProps[];
  premiumProductsCollectionLoading?: boolean;
};

export type WithDegreeAndMastertrackListsOutputProps = {
  degreeListLoading?: boolean;
  degreeList?: PremiumProductProps[];
  mastertrackList?: PremiumProductProps[];
  universityCertificateList?: PremiumProductProps[];
};

type BaseObject = {};

type PropsGenerator<P> = (props: P) => ApiInputProps;

const withDegreeAndMastertrackLists = <P extends BaseObject>(getVariablesFromProps: PropsGenerator<P>) =>
  compose<PremiumProductCollectionOutputProps & P, ApiInputProps>(
    setDisplayName('withDegreeAndMastertrackListsHOC'),
    withPremiumProductCollections<ApiInputProps & P>((propz) => {
      return {
        domains: getVariablesFromProps(propz).domains,
        productVariants: getVariablesFromProps(propz).productVariants,
        ssr: getVariablesFromProps(propz).ssr,
        fetchPolicy: getVariablesFromProps(propz).fetchPolicy,
      };
    }),
    withProps<WithDegreeAndMastertrackListsOutputProps, PremiumProductCollectionOutputProps>((props) => {
      const {
        degreeListFromPremiumProductsCollection = [],
        mastertrackListFromPremiumProductsCollection = [],
        universityCertificateListFromPremiumProductsCollection = [],
        premiumProductsCollectionLoading,
      } = props;

      return {
        degreeListLoading: premiumProductsCollectionLoading,
        degreeList: degreeListFromPremiumProductsCollection,
        mastertrackList: mastertrackListFromPremiumProductsCollection,
        universityCertificateList: universityCertificateListFromPremiumProductsCollection,
      };
    })
  );

export default withDegreeAndMastertrackLists;
